
import "@sparta.help.modules/engagement-search-module/dist/styles.css"
import "@sparta.help.modules/info-link-tiles-module/dist/styles.css"
import "@sparta.global.modules/connect-with-us-module/dist/styles.css"
import "@sparta.help.modules/single-column-content-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es5.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es5.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es5.js"

import "@sparta.help.modules/engagement-search-module/dist/es5.js"
import "@sparta.help.modules/info-link-tiles-module/dist/es5.js"
import "@sparta.global.modules/connect-with-us-module/dist/es5.js"
import "@sparta.help.modules/single-column-content-module/dist/es5.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  var bootExecs = [];
  bootExecs.push(function() { return spartaBootstrapUtility.init(arguments); });
  bootExecs.push(function() { return secureLinkUtility.run() });
  bootExecs.reduce(function(cur, next) {
    return cur.then(next);
  }, Promise.resolve()).then(function() {
    console.log('after - execute boot functions')
  });
})();
